document.addEventListener('DOMContentLoaded', function () {

  /* 3D tilt on product cards */
  var cards = document.querySelectorAll('.card');
  cards.forEach(function (card) {
    var bounds;
    card.addEventListener('mouseenter', function () {
      bounds = card.getBoundingClientRect();
    });
    card.addEventListener('mousemove', function (e) {
      if (!bounds) bounds = card.getBoundingClientRect();
      var x = e.clientX - bounds.left;
      var y = e.clientY - bounds.top;
      var cx = bounds.width / 2;
      var cy = bounds.height / 2;
      var rotateX = ((y - cy) / cy) * -6;
      var rotateY = ((x - cx) / cx) * 6;
      card.style.transform = 'perspective(900px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = 'perspective(900px) rotateX(0) rotateY(0) translateY(0)';
    });
  });

  /* reveal on scroll */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* mobile nav toggle */
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  /* quick add-to-cart (AJAX API) */
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          updateCartCount();
          setTimeout(function () { btn.textContent = 'Add to cart'; }, 1500);
        })
        .catch(function () { btn.textContent = 'Error'; });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('[data-cart-count]');
        if (el) el.textContent = cart.item_count;
      });
  }
});
